import { xEnsureFloat64 } from 'ml-spectra-processing';
import * as Filters from './filters/filters';
/**
 * Apply filters on {x:[], y:[]}
 * @returns A very important number
 */
export function filterXY(data, filters) {
    let result = {
        data: { x: xEnsureFloat64(data.x), y: xEnsureFloat64(data.y) },
    };
    const logs = [];
    for (const filter of filters) {
        const start = Date.now();
        // eslint-disable-next-line import/namespace
        const filterFct = Filters[filter.name];
        if (!filterFct) {
            throw new Error(`Unknown filter: ${filter.name}`);
        }
        // @ts-expect-error some method have options and some other ones don't have any options
        result = filterFct(result.data, filter.options);
        logs.push({
            name: filter.name,
            time: Date.now() - start,
        });
    }
    return { logs, data: result.data };
}
//# sourceMappingURL=filterXY.js.map